import { ADMINISTRATIVE_BUILDINGS_SUBSUBSECTOR_ABBREVIATION, ADMINISTRATIVE_BUILDINGS_SUBSUBSECTOR_ID, } from "../bisko/constants";
import { RETROFIT_BUILDING_TYPE } from "./retrofit-building-type";
export const ADMINISTRATIVE_BUILDING_ENVELOPE_RETROFIT_PROFILE = {
    slug: "administrative-building-envelope-retrofit",
    subsubsectorId: ADMINISTRATIVE_BUILDINGS_SUBSUBSECTOR_ID,
    subsubsectorAbbreviation: ADMINISTRATIVE_BUILDINGS_SUBSUBSECTOR_ABBREVIATION,
    defaultFloorAreaSquareMetreByBuildingType: { [RETROFIT_BUILDING_TYPE.ADMINISTRATIVE_BUILDING]: 1600 },
    usefulHeatOutputKwhPerSquareMetre: {
        UNRENOVATED_MEAN: 187.3,
        VERY_HIGH: 282.9,
        HIGH: 171.3,
        MEDIUM: 107.6,
        LOW: 51.8,
        VERY_LOW: 26.4,
    },
    canClaimWholeNodeConsumption: true,
};
